import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ChargingNetworkWisApi } from "./ChargingNetworkWiseApi";
import { ChargingNetworkWiseConstant } from "./ChargingNetworkWiseConstant";
import { CoupanNetworkWiseParser } from "./ChargingNetworkWiseParser";

function* ChargingNetworkWiseSaga() {
  try {
    yield put({
      type: ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_REQUEST,
    });
    const res = yield call(ChargingNetworkWisApi.getChargingNetworkWisApi);

    const payload = CoupanNetworkWiseParser.getCouponNetworkWiseParser(res);

    yield put({
      type: ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_RESPONSE,
      payload: [],
    });
  }
}

export function* registerChargingNetworkWiseSaga() {
  yield takeLatest(
    ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_SAGA,
    ChargingNetworkWiseSaga
  );
}
